import { t } from "@lingui/macro";
import React from "react";
import { Image } from "react-native";

import { CreditCardIcon } from "@whoosh/design-system/src/components/icons_v2/general";

import { CardBrand } from "../__generated__/SquareCardFragment.graphql";

export const GetCardIconFromBrand = (brand: CardBrand) => {
  switch (brand) {
    case "AMERICAN_EXPRESS":
      return (
        <Image
          source={{ uri: "/cardBrands/amex.png" }}
          alt={t`AMEX`}
          resizeMode="contain"
          style={{ width: 16, height: 16 }}
        />
      );

    case "DISCOVER":
      return (
        <Image
          source={{ uri: "/cardBrands/discover.png" }}
          alt={t`Discover`}
          resizeMode="contain"
          style={{ width: 12, height: 12 }}
        />
      );

    case "JCB":
      return (
        <Image
          source={{ uri: "/cardBrands/jcb.png" }}
          alt={t`JCB`}
          resizeMode="contain"
          style={{ width: 25.6, height: 16 }}
        />
      );

    case "MASTERCARD":
      return (
        <Image
          source={{ uri: "/cardBrands/mastercard.png" }}
          alt={t`Mastercard`}
          resizeMode="contain"
          style={{ width: 19, height: 12 }}
        />
      );

    case "CHINA_UNIONPAY":
      return (
        <Image
          source={{ uri: "/cardBrands/unionpay.png" }}
          alt={t`UnionPay`}
          resizeMode="contain"
          style={{ width: 25.78, height: 16 }}
        />
      );

    case "VISA":
      return (
        <Image
          source={{ uri: "/cardBrands/visa.png" }}
          alt={t`VISA`}
          resizeMode="contain"
          style={{ width: 22, height: 7 }}
        />
      );

    default:
      return <CreditCardIcon color="icon-inverse-subtle" />;
  }
};
